import { render, staticRenderFns } from "./TableRowBase.vue?vue&type=template&id=2d3141ff&lang=pug&"
import script from "./TableRowBase.vue?vue&type=script&lang=js&"
export * from "./TableRowBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3141ff')) {
      api.createRecord('2d3141ff', component.options)
    } else {
      api.reload('2d3141ff', component.options)
    }
    module.hot.accept("./TableRowBase.vue?vue&type=template&id=2d3141ff&lang=pug&", function () {
      api.rerender('2d3141ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowBase.vue"
export default component.exports